<template>
  <v-app>
    <div class="div-not-found text-center">
      <h1>Página não encontrada</h1>
      <v-btn color="primary" @click="Helpers.logout()">
        <v-icon>mdi-keyboard-backspace</v-icon>
        Voltar
      </v-btn>
    </div>
  </v-app>
</template>

<script>
export default {

}
</script>

<style scoped>
</style>
